import React, { useState, useEffect } from "react";
import { VictoryPie, VictoryTooltip } from "victory";
import axios from "axios";

export function StockPieForCommercialsAdminV({ commercials }) {
  const [stockData, setStockData] = useState(null);

  const fetchPieChartData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/getCommerciauxStock`,
        { withCredentials: true }
      );
      // Map API response to the format required by VictoryPie
      const formattedData = response?.data?.map((item) => ({
        x: item.name,
        y: item.stock,
        info: `Stock: ${item.stock}`,
      }));
      setStockData(formattedData);
    } catch (error) {
      console.error("Error fetching pie chart data:", error);
    }
  };

  useEffect(() => {
    fetchPieChartData();
  }, []);

  // Mock data for commercials
  const data = [
    { x: "Slim Saaidi", y: 30, info: "Stock: 30" },
    { x: "Zied Zied", y: 35, info: " Stock: 35" },
    { x: "Zied Belgasmi", y: 25, info: " Stock: 25" },
    { x: "Louay Smida", y: 10, info: " Stock: 10" },
  ];

  return (
    <div className="flex flex-col items-center  w-1/3 border py-2">
      <div className="max-w-[500px] mx-auto " id="chart">
        <VictoryPie
          labelComponent={<VictoryTooltip />}
          innerRadius={70} // Donut chart effect
          padAngle={3} // Spacing between slices
          cornerRadius={5} // Rounded edges
          data={stockData}
          colorScale={["#4CAF50", "#FF9800", "#9C27B0", "#F44336", "#2196F3"]}
          style={{
            data: {
              fillOpacity: 0.9, // Slight transparency
              stroke: "#E0E0E0", // White border
              strokeWidth: 2,
            },
            labels: {
              fontSize: 14, // Label font size
              fill: "#333", // Label color
              fontWeight: "bold",
            },
          }}
          labels={({ datum }) => `${datum.x}: ${datum.y}`} // Custom labels
        />
      </div>
      {/* Commercials List */}
      <div className="w-full px-4">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
          Détails des commerciaux
        </h3>
        <ul className="space-y-2 max-w-[500px]">
          {stockData?.map((commercial, index) => (
            <li
              key={index}
              className="flex justify-between items-center bg-gray-100 dark:bg-gray-700 p-2 rounded-md shadow-sm">
              <span className="text-gray-900 dark:text-white font-medium">
                {commercial.x}
              </span>
              <span
                className="text-sm text-gray-500 dark:text-gray-400"
                title={commercial.info} // Tooltip for additional info
              >
                {commercial.info}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
